<template>
  <v-card-component
    :title="getTitle"
    :icon="parentType === 'mother' ? 'mdi-human-female' : 'mdi-human-male'"
  >
    <v-row>
      <v-col>
        <v-row>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium text-capitalize"
              >{{ parentType === 'father' ? 'Parent' : 'Mother' }}
              <span v-if="parentType === 'father'">/ Guardian</span> Name</span
            >
            <span class="error--text ml-1" v-if="parentType !== 'mother'"
              >*</span
            >
            <v-text-field
              type="text"
              placeholder="Enter Name"
              class="my-0 py-1"
              single-line
              v-model.trim="value[`${parentType}Name`]"
              :readonly="isReadonly"
              :disabled="isDisabled"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium text-capitalize"
              >{{ parentType === 'father' ? 'Parent' : 'Mother' }}
              <span v-if="parentType === 'father'">/ Guardian</span> Mobile
              No.</span
            >
            <span class="error--text ml-1" v-if="parentType !== 'mother'"
              >*</span
            >
            <v-text-field
              placeholder="Enter Mobile Number"
              class="my-0 py-1"
              maxlength="14"
              pattern="^([0|+[0-9]{1,5})?([6-9][0-9]{9})$"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              type="text"
              v-model="value[`${parentType}Mobile`]"
              :readonly="formType == 'applicationForm' ? true : isReadonly"
              :disabled="
                (formType == 'applicationForm' ? true : isDisabled) ||
                (enquiryCode ? true : false)
              "
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium text-capitalize"
              >{{ parentType === 'father' ? 'Parent' : 'Mother' }}
              <span v-if="parentType === 'father'">/ Guardian</span> Email</span
            >
            <span
              class="error--text ml-1"
              v-if="parentType !== 'mother' && isEnquiry === false"
              >*</span
            >
            <v-text-field
              placeholder="Enter Email-ID"
              class="my-0 py-1"
              type="email"
              v-model="value[`${parentType}EmailID`]"
              :readonly="isReadonly"
              :disabled="isDisabled"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            sm="6"
            v-if="formType !== 'admission' && formType !== 'studEdit'"
          >
            <span class="body-2 font-weight-medium text-capitalize"
              >{{ parentType === 'father' ? 'Parent' : 'Mother' }}
              <span v-if="parentType === 'father'">/ Guardian</span>
              Occupation</span
            >
            <span
              class="error--text ml-1"
              v-if="parentType !== 'mother' && parentType !== 'father'"
              >*</span
            >
            <v-text-field
              placeholder="Enter Occupation"
              class="my-0 py-1"
              v-model="value[`${parentType}Occupation`]"
              type="text"
              :readonly="isReadonly"
              :disabled="isDisabled"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card-component>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
export default {
  name: 'ParentElement',
  data: function () {
    return {
      isReadonly: false,
      isDisabled: false,
      isEnquiry: false
    }
  },
  props: {
    enquiryCode: {
      default: '',
      type: String
    },
    formType: {
      default: '',
      type: String
    },
    parentType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    }
  },
  components: {
    VCardComponent
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },
  created () {
    if (this.parentType === 'mother') {
      this.getTitle = "Mother's Details"
    } else {
      this.getTitle = "Parent's / Guardian Details"
    }

    if (this.formType === 'enquiry') {
      this.isEnquiry = true
    }

    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  }
}
</script>
